module.exports = __webpack_public_path__ + "static/media/orias.63f2088e.png";